import React, { useEffect, useState } from 'react';
import { logout, useUserData } from '~/utils/auth';
import { getCashier } from '~/store/cashier';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import { CashierStatus } from '~/types/Cashier';
import { Alert, Button, Form, InputNumber, Typography } from 'antd';
import { openCashier } from '../../../Cashier/api';
import { useLoadingSetter } from '~/providers/LoadingProvider';
import './style.css';
import message from '~/utils/message';
import { useCheckPermission } from '~/store/permission';

const OpenCashierOverlay = () => {
  const user = useUserData();
  const setLoading = useLoadingSetter();
  const [error, setError] = useState<string | null>(null);
  const [needOpenCashier, setNeedOpenCashier] = useState(false);
  const checkPermission = useCheckPermission();
  const isAllowedCashier = checkPermission('cashierBalancing:c');

  useEffect(() => {
    if (isAllowedCashier) {
      getCashier({ refresh: true }).then((cashier) => {
        if (cashier.status === CashierStatus.Closed) {
          setNeedOpenCashier(true);
        }
      });
    }
  }, []);

  const onFinish = async (values: any) => {
    setError(null);
    setLoading(true);
    const { error, errorMsg } = await openCashier({ balance: values.balance });
    if (!error) {
      try {
        const cashier = await getCashier({ refresh: true });
        setLoading(false);
        if (cashier.status === CashierStatus.Open) {
          message.success('Kasir sudah dibuka');
          setNeedOpenCashier(false);
        }
      } catch (e: any) {
        setLoading(false);
        setError(e.message);
      }
    } else {
      setLoading(false);
      setError(errorMsg);
    }
  };

  const onLogout = () => {
    logout();
  };

  if (!needOpenCashier) return null;
  return (
    <Container
      style={{
        position: 'fixed',
        backgroundColor: 'white',
        zIndex: 50,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <Header title="Buka Kasir" hideBackButton hideHomeButton />
      <div className="open-cashier-overlay-container">
        <Typography.Title level={4}>{`Kasir: ${user?.name}`}</Typography.Title>
        {error ? <Alert type="error" message={error} /> : null}
        <Form name="openCashier" onFinish={onFinish} style={{ marginTop: 16 }}>
          <Form.Item
            label="Saldo Awal"
            name="balance"
            rules={[{ required: true, message: 'Saldo awal harus diisi' }]}
          >
            <InputNumber style={{ width: '100%' }} size="large" />
          </Form.Item>
          <Form.Item style={{ marginTop: 32 }}>
            <Button
              htmlType="submit"
              block
              size="large"
              type="primary"
              className="open-cashier-overlay-btn-submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
        <Button block size="large" danger onClick={onLogout}>
          Logout
        </Button>
      </div>
    </Container>
  );
};

export default OpenCashierOverlay;
